import React, { useState } from 'react';
import { Logo } from '../components/Logo';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { Card } from '../components/Card';
interface LoginScreenProps {
  onLogin: () => void;
}
export function LoginScreen({
  onLogin
}: LoginScreenProps) {
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const handleSendCode = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) setStep('code');
  };
  const handleVerify = (e: React.FormEvent) => {
    e.preventDefault();
    if (code.length === 6) onLogin();
  };
  return <div className="min-h-screen flex items-center justify-center p-4 bg-navy" data-id="element-678" data-mp="kmn3om6k57rb">
      <Card className="w-full max-w-md p-8" data-id="element-679" data-mp="kkk5vfz5yac1">
        <div className="flex flex-col items-center mb-8" data-id="element-680" data-mp="3t1olvifwq7ee">
          <Logo size="lg" className="mb-2" data-id="element-681" data-mp="3t03shw5bwui4" />
        </div>

        {step === 'email' ? <form onSubmit={handleSendCode} className="space-y-6" data-id="element-682" data-mp="3o1984prpqxvw">
            <div data-id="element-683" data-mp="2gbao35o11fju">
              <Input type="email" placeholder="Enter your email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus data-id="element-684" data-mp="2gbtupq888hik" />
            </div>

            <Button type="submit" fullWidth size="lg" data-id="element-685" data-mp="2u2ff5jdbwzik">
              Send Code
            </Button>

            <p className="text-sm text-gray-400 text-center" data-id="element-686" data-mp="1xe9d947skl7z">
              We'll send a 6-digit verification code to your email.
            </p>
          </form> : <form onSubmit={handleVerify} className="space-y-6" data-id="element-687" data-mp="26decydv3aklq">
            <div data-id="element-688" data-mp="26g8xs6i0m7fo">
              <Input type="text" placeholder="000000" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} required autoFocus className="text-center text-2xl tracking-widest font-mono" data-id="element-689" data-mp="2bcqzsylynrob" />
            </div>

            <Button type="submit" fullWidth size="lg" disabled={code.length !== 6} data-id="element-690" data-mp="1iol3eqyyes0q">
              Verify
            </Button>

            <div className="text-center space-y-2" data-id="element-691" data-mp="1roznxo43g336">
              <p className="text-sm text-gray-400" data-id="element-692" data-mp="1rpiygjrezp76">
                Enter the code sent to{' '}
                <span className="text-white font-medium" data-id="element-693" data-mp="13zydjvbpahv9">{email}</span>
              </p>
              <button type="button" className="text-sm text-amber hover:text-amber-hover transition-colors" onClick={() => setStep('email')} data-id="element-694" data-mp="z1dfo2jx8a9z">
                Resend code
              </button>
            </div>
          </form>}
      </Card>
    </div>;
}